<template>
<div class="first-question">
	<grid>
		<grid-item size="1/1">
			<h2 class="question-text">{{ question.text }}</h2>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="27/60">
			<label :class="{ active: activeOption == 0 }">
				<input hidden type="radio"
					:value="0"
					v-model="response"
				/>
				<span>
					{{ question.responses[0].text }}
				</span>
			</label>
		</grid-item>
		<grid-item size="6/60">
			<span class="separator">OR</span>
		</grid-item>
		<grid-item size="27/60" >
			<label :class="{ active: activeOption == 1 }">
				<input hidden type="radio"
					:value="1"
					v-model="response"
				/>
				<span>
					{{ question.responses[1].text }}
				</span>
			</label>
		</grid-item>
	</grid>
</div>
</template>

<script>
export default {
	props: [
		'value',
		'question'
	],
	data: () => ({
		activeOption: null
	}),
	computed: {
		response: {
			get() { return this.value },
			set(value) { this.$emit('input', value) }
		}
	},
	watch: {
		response(item) {
			this.activeOption = item
		}
	}
}
</script>

<style lang="scss">
.first-question {
	.separator {
		line-height: 100px;
		color: #fff;
		font-size: 14px;
	}
	label {
		height: 100px;
		padding: 0px 40px;
		line-height: 100px;
	}
}
</style>
